var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlickr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8125 25C37.8125 28.2812 35.1562 30.9375 31.875 30.9375C28.5937 30.9375 25.9375 28.2812 25.9375 25C25.9375 21.7188 28.5937 19.0625 31.875 19.0625C35.1562 19.0625 37.8125 21.7188 37.8125 25Z",
    fill: "#FF0084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 25C24.2188 28.2812 21.5625 30.9375 18.2812 30.9375C15 30.9375 12.3438 28.2812 12.3438 25C12.3438 21.7188 15 19.0625 18.2812 19.0625C21.4062 19.0625 24.2188 21.7188 24.2188 25Z",
    fill: "#0063DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlickr);
export default __webpack_public_path__ + "static/media/Flickr.0946589385afc492126b3bcc4aac8fee.svg";
export { ForwardRef as ReactComponent };